module.exports = __webpack_public_path__ + "img/product_mb_new_02.cbe9ac3.svg";